<div class="canvas-body">
    <ngx-spinner bdColor="rgba(255, 255, 255, 1)" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>

    <!-- Sequência Principal -->
    <div class="main-path" #mainPathRef>
        @if ($isBootstrapFinished()) {
            @if ($hasGatewayPath()) {
                <div class="path-name">Sequência Principal</div>
            }

            @if ($mainPathFlowObjects().length == 0) {
                <div class="msg empty">Adicione uma Tarefa</div>
            } @else {
                @for (grouping of $mainPathGroupings(); track grouping) {
                    <selected-grouping [_model]="grouping"
                                       [_isReadOnlyMode]="$isReadOnlyMode()"
                                       [_hasGatewayPath]="$hasGatewayPath()"
                                       [_selectedGroupings]="$selectedGroupings()"
                                       [_selectedGroupingColumns]="$mainPathGroupingColumns()"
                                       [_selectedFlowObjects]="$mainPathFlowObjects()"
                                       (_toggleEditAreaEvent)="_toggleEditAreaEvent.emit($event)"
                                       (_removeGroupingEvent)="removeGrouping($event.event, $event.flowObject)"
                                       (_changeTaskTypeEvent)="changeTaskType($event.event, $event.flowObject)"
                                       (_moveGroupingBackwardsEvent)="moveGroupingBackwards($event.event, $event.flowObject)"
                                       (_moveGroupingForwardsEvent)="moveGroupingForwards($event.event, $event.flowObject)"
                                       (_moveGroupingUpwardsEvent)="moveGroupingUpwards($event.event, $event.flowObject)"
                                       (_moveGroupingDownwardsEvent)="moveGroupingDownwards($event.event, $event.flowObject)"
                                       (_notifyFlowObjectLoadedEvent)="gatherMainPathFlowObjectRefs($event)"
                    ></selected-grouping>
                }
            }
        }
    </div>

    <!-- Sequência A -->
    @if ($hasGatewayPath()) {
        <div class="gateway-path first" #firstGatewayPathRef>
            @if ($isBootstrapFinished()) {
                <div class="path-name">
                    {{$firstGatewayPathName()}}
                </div>

                @if ($firstGatewayPathFlowObjects().length == 0) {
                    <div class="msg empty">Adicione uma Tarefa</div>
                } @else {
                    @for (grouping of $firstGatewayPathGroupings(); track grouping) {
                        <selected-grouping [_model]="grouping"
                                           [_isReadOnlyMode]="$isReadOnlyMode()"
                                           [_hasGatewayPath]="$hasGatewayPath()"
                                           [_selectedGroupings]="$selectedGroupings()"
                                           [_selectedGroupingColumns]="$firstGatewayPathGroupingColumns()"
                                           [_selectedFlowObjects]="$firstGatewayPathFlowObjects()"
                                           (_toggleEditAreaEvent)="_toggleEditAreaEvent.emit($event)"
                                           (_removeGroupingEvent)="removeGrouping($event.event, $event.flowObject)"
                                           (_changeTaskTypeEvent)="changeTaskType($event.event, $event.flowObject)"
                                           (_moveGroupingBackwardsEvent)="moveGroupingBackwards($event.event, $event.flowObject)"
                                           (_moveGroupingForwardsEvent)="moveGroupingForwards($event.event, $event.flowObject)"
                                           (_moveGroupingUpwardsEvent)="moveGroupingUpwards($event.event, $event.flowObject)"
                                           (_moveGroupingDownwardsEvent)="moveGroupingDownwards($event.event, $event.flowObject)"
                                           (_notifyFlowObjectLoadedEvent)="gatherFirstGatewayPathFlowObjectRefs($event)"
                        ></selected-grouping>
                    }
                }
            }
        </div>
    }

    <!-- Sequência B -->
    @if ($hasGatewayPath()) {
        <div class="gateway-path second" #secondGatewayPathRef>
            @if ($isBootstrapFinished()) {
                <div class="path-name">
                    {{$secondGatewayPathName()}}
                </div>

                @if ($secondGatewayPathFlowObjects().length == 0) {
                    <div class="msg empty">Adicione uma Tarefa</div>
                } @else {
                    @for (grouping of $secondGatewayPathGroupings(); track grouping) {
                        <selected-grouping [_model]="grouping"
                                           [_isReadOnlyMode]="$isReadOnlyMode()"
                                           [_hasGatewayPath]="$hasGatewayPath()"
                                           [_selectedGroupings]="$selectedGroupings()"
                                           [_selectedGroupingColumns]="$secondGatewayPathGroupingColumns()"
                                           [_selectedFlowObjects]="$secondGatewayPathFlowObjects()"
                                           (_toggleEditAreaEvent)="_toggleEditAreaEvent.emit($event)"
                                           (_removeGroupingEvent)="removeGrouping($event.event, $event.flowObject)"
                                           (_changeTaskTypeEvent)="changeTaskType($event.event, $event.flowObject)"
                                           (_moveGroupingBackwardsEvent)="moveGroupingBackwards($event.event, $event.flowObject)"
                                           (_moveGroupingForwardsEvent)="moveGroupingForwards($event.event, $event.flowObject)"
                                           (_moveGroupingUpwardsEvent)="moveGroupingUpwards($event.event, $event.flowObject)"
                                           (_moveGroupingDownwardsEvent)="moveGroupingDownwards($event.event, $event.flowObject)"
                                           (_notifyFlowObjectLoadedEvent)="gatherSecondGatewayPathFlowObjectRefs($event)"
                        ></selected-grouping>
                    }
                }
            }
        </div>
    }
</div>
